import BulkPostGroups from "./BulkPostGroups";

export default BulkPostGroups;